import React from 'react';

import { useSessionTokensState, useSessionTokensActions } from './SessionTokensContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';

const SessionTokensTable = () => {
  const sessionTokensState = useSessionTokensState();
  const { openDeleteSessionTokenModal } = useSessionTokensActions();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const handleDelete = (token) => {
    openDeleteSessionTokenModal(token);
  };

  const groupedTokens = sessionTokensState?.sessionTokens?.reduce((groups, token) => {
    const userEmail = token.userEmail === 'Unknown (Account Deleted)'
      ? 'Orphaned Session Tokens'
      : token.userEmail;
    if (!groups[userEmail]) {
      groups[userEmail] = [];
    }
    groups[userEmail].push(token);
    return groups;
  }, {}) || {};

  const sortedGroups = Object.entries(groupedTokens).sort(([emailA], [emailB]) => {
    if (emailA === 'Orphaned Session Tokens') return 1;
    if (emailB === 'Orphaned Session Tokens') return -1;
    return emailA.localeCompare(emailB);
  });

  return (
    <>
      {sortedGroups.map(([userEmail, tokens]) => (
        <div key={userEmail} style={{ marginBottom: '2rem' }}>
          <h3 style={{
            marginBottom: '1rem',
            color: userEmail === 'Orphaned Session Tokens' ? '#d9534f' : 'inherit'
          }}>
            {userEmail}
            {userEmail === 'Orphaned Session Tokens' && (
              <span style={{ fontSize: '0.8em', fontWeight: 'normal', marginLeft: '0.5rem' }}>
                ({tokens.length} token{tokens.length !== 1 ? 's' : ''})
              </span>
            )}
          </h3>
          <Table>
            <Thead>
              <Tr>
                <Th>Remote IP</Th>
                <Th>User Agent</Th>
                <Th>Expires At</Th>
                <Th>Created At</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {tokens.map(token => (
                <Tr key={token.id}>
                  <Td>{token.remoteIp}</Td>
                  <Td>{token.userAgent || 'N/A'}</Td>
                  <Td>{formatDate(token.expiresAt)}</Td>
                  <Td>{formatDate(token.createdAt)}</Td>
                  <Td>
                    <Button
                      onClick={() => handleDelete(token)}
                      variant="danger"
                    >
                      Delete
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
      ))}
    </>
  );
};

export default SessionTokensTable;
